import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-analytics-redirect',
    templateUrl: './analytics-redirect.component.html',
    styleUrls: ['./analytics-redirect.component.scss']
})
export class AnalyticsRedirectComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
